import { useRootStore } from "Store/RootStore";

export const useAppSettings = () => {
    const settingStore = useRootStore("AppSettingStore");
    return settingStore.settings;
};
